/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * POAM item create request
 * @export
 * @interface POAMItemCreateRequest
 */
export interface POAMItemCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof POAMItemCreateRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMItemCreateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMItemCreateRequest
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof POAMItemCreateRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof POAMItemCreateRequest
     */
    remarks?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMItemCreateRequest
     */
    budget?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMItemCreateRequest
     */
    findingId?: string;
}

/**
 * Check if a given object implements the POAMItemCreateRequest interface.
 */
export function instanceOfPOAMItemCreateRequest(value: object): value is POAMItemCreateRequest {
    return true;
}

export function POAMItemCreateRequestFromJSON(json: any): POAMItemCreateRequest {
    return POAMItemCreateRequestFromJSONTyped(json, false);
}

export function POAMItemCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): POAMItemCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'status': json['status'] == null ? undefined : json['status'],
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'budget': json['budget'] == null ? undefined : json['budget'],
        'findingId': json['findingId'] == null ? undefined : json['findingId'],
    };
}

export function POAMItemCreateRequestToJSON(json: any): POAMItemCreateRequest {
    return POAMItemCreateRequestToJSONTyped(json, false);
}

export function POAMItemCreateRequestToJSONTyped(value?: POAMItemCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'status': value['status'],
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'remarks': value['remarks'],
        'budget': value['budget'],
        'findingId': value['findingId'],
    };
}

